import "./Footer.css";
import React from "react";

function Footer(props) {
  return (
    <div>
      <footer className="footerContainer">
        <nav className="navList">
          <a className="href" href="/">
            <p className="footerText"> home </p>
          </a>
          <a className="href" href="/privacy">
            <p className="footerText"> privacy </p>
          </a>
          <a className="href" href="/about">
            <p className="footerText"> about </p>
          </a>
        </nav>
      <a className="href" href="https://cerise-technology.com/">
        <p className="footerText">© 2026 Cerise Technology LLC</p>
      </a>
      {/* <a className="href" href="https://cerasus-creative-studios.com/">
        <p className="footerText">graphics and design by Cerasus Creative Studios</p>
      </a> */}
      </footer>
    </div>
  );
}

export default Footer;
